import { motion } from "motion/react";
import { FaStar, FaQuoteLeft } from "react-icons/fa";
import SectionSepratorHeader from "../../components/ui/section-seprator-header";
import Noise from "../../components/core/noise";

const reviews = [
  {
    name: "Marcus Thorne",
    role: "Director of Ops, Arkon Steel",
    content:
      "The precision of their metal signage is unmatched. They don't just build signs; they engineer brand confidence. A critical partner for our facility branding.",
    rating: 5,
  },
  {
    name: "Elena Rodriguez",
    role: "Brand Architect, Vector Media",
    content:
      "Metal FX delivered a 15-foot pylon sign that survived a category 3 storm without a scratch. Their industrial-grade commitment is the real deal.",
    rating: 5,
  },
  {
    name: "Jameson Blake",
    role: "Commercial Developer",
    content:
      "Finding a team that understands both the aesthetic and structural requirements of sign engineering is rare. These guys are the gold standard.",
    rating: 4,
  },
  {
    name: "Sarah Chen",
    role: "Property Manager, Global Hub",
    content:
      "Clean lines, professional installation, and bulletproof materials. The lime accents give our building a tech-forward look that tenants love.",
    rating: 5,
  },
  {
    name: "Robert Vance",
    role: "Marketing Head, Zenith Corp",
    content:
      "Working with the direct response unit was seamless. They turned a complex facade concept into a physical reality in record time.",
    rating: 5,
  },
];

const ReviewCard = ({ review }: { review: (typeof reviews)[0] }) => (
  <motion.div
    whileHover={"hover"}
    initial="initial"
    className="cursor-pointer w-[380px] h-[280px]  p-8 rounded-4xl bg-white/5 border border-white/10 relative overflow-hidden group"
  >
    <Noise className="opacity-[0.03] group-hover:opacity-[0.06] transition-opacity duration-500" />

    <div className="relative z-10 flex flex-col h-full justify-between">
      <div className="w-full flex flex-1 flex-col">
        <div className="flex gap-1 mb-4 w-full">
          {[...Array(5)].map((_, i) => (
            <FaStar
              key={i}
              className={i < review.rating ? "text-[#4991b8]" : "text-zinc-800"}
              size={12}
            />
          ))}
        </div>
        <motion.div
          variants={{
            initial: { scale: 1 },
            hover: { scale: 1.2 },
          }}
          transition={{
            ease: "easeIn",
            duration: 0.2,
          }}
          className="text-[#4991b8]/20 absolute -top-2 -right-2"
        >
          <FaQuoteLeft size={60} />
        </motion.div>
        <div className="w-full flex-1">
          <span className="text-zinc-400 text-lg wrap-break-word line-clamp-4 font-medium flex-1 min-w-0">
            {review.content}
          </span>
        </div>
      </div>
      <div className="flex items-center gap-4 mt-6">
        <div className="w-10 h-10 rounded-full bg-linear-to-br from-[#4991b8] to-[#4991b8] flex items-center justify-center font-black text-black text-xs">
          {review.name
            .split(" ")
            .map((n) => n[0])
            .join("")}
        </div>
        <div>
          <h4 className="text-white font-black text-sm uppercase tracking-wider">
            {review.name}
          </h4>
          <p className="text-zinc-600 font-bold text-[10px] uppercase tracking-widest">
            {review.role}
          </p>
        </div>
      </div>
    </div>
    <div className="absolute inset-x-0 bottom-0 h-1 bg-[#4991b8] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
  </motion.div>
);

const Reviews = () => {
  return (
    <section className="w-full py-14 bg-[#111212] overflow-hidden relative">
      <SectionSepratorHeader
        title="INDUSTRIAL TESTIMONIALS"
        subtitle={
          <>
            Forged in <span className="text-[#4991b8] italic">Trust</span>
          </>
        }
        description="Reliability at scale. Here is what leading industrial properties and brands say about our identifies."
      ></SectionSepratorHeader>
      <div className="relative flex flex-nowrap gap-3 w-full  overflow-hidden py-10">
        {Array.from({ length: 2 }).map((_a, i) => (
          <motion.div
            key={`marquee-${i}`}
            className="flex gap-8"
            animate={{ x: [0, "-100%"] }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 30,
                ease: "linear",
              },
            }}
          >
            {[...reviews, ...reviews, ...reviews].map((review, i) => (
              <ReviewCard key={i} review={review} />
            ))}
          </motion.div>
        ))}

        <div className="absolute inset-y-0 left-0 w-32 bg-linear-to-r from-[#111212] to-transparent z-20" />
        <div className="absolute inset-y-0 right-0 w-32 bg-linear-to-l from-[#111212] to-transparent z-20" />
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-full pointer-events-none opacity-5">
        <span className=" text-[6rem] md:text-[25rem] font-black text-white select-none whitespace-nowrap">
          REPUTATION REPUTATION REPUTATION
        </span>
      </div>
    </section>
  );
};

export default Reviews;
